/**
 * Lists all possible frequency values.
 */
export default [
  { key: 25, value: '25' },
  { key: 40, value: '40' },
  { key: 50, value: '50' },
  { key: 80, value: '80' },
  { key: 120, value: '120' },
  { key: 132, value: '132' },
]
